<template>
  <div>
    <div class="block-content">
      <div
        v-if="!show"
        class="spinner-loader"
      >
        <sync-loader />
        <p>Loading ...</p>
      </div>
      <div
        v-if="show && !filter"
        class="tabs is-toggle is-fullwidth"
      >
        <ul>
          <li
            v-for="tab in tabs"
            :key="`${tab.name}`"
            :class="{'is-active': tab.name === activeTab.name}"
            @click="switchTab(tab.name)"
          >
            <a>{{ tab.tablabel }}</a>
          </li>
        </ul>
      </div>


      <race-standing :show="show" :user="user" :token="token" :activeRegion="activeRegion" @switchRegion="switchRegion" :standing-data="standingData"/>


    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import RaceStanding from './RaceStanding.vue'

  export default {
    name: 'StandingMain',
    components: {
      RaceStanding
    },
    props: ['token', 'user', 'filter'],
    data() {
      return {
        standingData: null,
        activeRegion: null,
        show: false,
        tabs: [],
        activeTab: '',
      }
    },
    mounted() {
      this.activeRegion = this.$route.params.region || null
      this.getTabs()
    },
    methods: {
      getTabs() {
        this.$axios({
          method: 'POST',
          url: `general/points/${this.activeRegion}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.tabs = []
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].type === 'RACE') {
                this.tabs.push(res.data[i])
              }
            }
            if (this.filter || this.$route.params.filter) {
              let tab = this.tabs.find((t) => {
                return t.name === (this.filter||this.$route.params.filter);
              })
              this.activeTab = tab
            } else this.activeTab = this.tabs[0]
            // Get players standing
            if (this.tabs.length > 0) {
              this.getStanding()
            } else {
              this.standing = []
              this.players = []
              this.show = true
            }
          })
          .catch((error) => {
            console.log('Error', error)
          })
      },
      getStanding() {
        this.show = false
        this.$axios({
          method: 'POST',
          url: `general/points/${this.activeRegion}/${this.activeTab.name}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.standingData = res.data
            this.standing = res.data
            this.tabHeaderLabel = res.data.headerLabel
            this.tabHelpText = res.data.helptext
            this.tabHelpLink = res.data.helplink
            this.special_text = res.data.special_text
            this.players = res.data.pointList
            this.show = true
            this.activeRegion = res.data.region
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      },
      switchTab(tab) {
        this.activeTab = this.tabs.find(t => t.name === tab)
        this.$router.push({path: `/races/${tab}`})
        this.getStanding()
      },
      switchRegion(region) {
        this.activeRegion = region
        this.getTabs()
        this.$router.push({path: `/races`})
      },
    }
  }
</script>
